import { Component, ChangeDetectionStrategy } from "@angular/core";
import { CustomerMapComponent } from "../../shared/widgets/customer-map/customer-map.component";

@Component({
  standalone: true,
  selector: "app-map",
  imports: [CustomerMapComponent],
  templateUrl: "./map.component.html",
  styleUrl: "./map.component.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [],
})
export class MapComponent {}
